namespace Gamification.Gamification {
    export interface UtentiProdottiConProprietaRow {
        IdUtenteProdotto?: number;
        IdUtente?: number;
        IdProdotto?: number;
        IdentifierUtente?: string;
        Cognome?: string;
        Nome?: string;
        Email?: string;
        Locked?: number;
        Prodotto?: string;
        IdTipologiaProdotti?: number;
        IdentifierProdotto?: string;
        UserId?: number;
        CognomeAdmin?: string;
        NomeAdmin?: string;
        Azienda?: string;
        TipologiaProdotti?: string;
    }

    export namespace UtentiProdottiConProprietaRow {
        export const idProperty = 'IdUtenteProdotto';
        export const nameProperty = 'Email';
        export const localTextPrefix = 'Gamification.UtentiProdottiConProprieta';
        export const lookupKey = 'Gamification.UtentiProdottiConProprieta';

        export function getLookup(): Q.Lookup<UtentiProdottiConProprietaRow> {
            return Q.getLookup<UtentiProdottiConProprietaRow>('Gamification.UtentiProdottiConProprieta');
        }
        export const deletePermission = 'Role:Admin';
        export const insertPermission = 'Role:Admin';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Role:Admin';

        export declare const enum Fields {
            IdUtenteProdotto = "IdUtenteProdotto",
            IdUtente = "IdUtente",
            IdProdotto = "IdProdotto",
            IdentifierUtente = "IdentifierUtente",
            Cognome = "Cognome",
            Nome = "Nome",
            Email = "Email",
            Locked = "Locked",
            Prodotto = "Prodotto",
            IdTipologiaProdotti = "IdTipologiaProdotti",
            IdentifierProdotto = "IdentifierProdotto",
            UserId = "UserId",
            CognomeAdmin = "CognomeAdmin",
            NomeAdmin = "NomeAdmin",
            Azienda = "Azienda",
            TipologiaProdotti = "TipologiaProdotti"
        }
    }
}
